import script from "./RecensementList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecensementList.vue?vue&type=script&setup=true&lang=js"

import "./RecensementList.vue?vue&type=style&index=0&id=0ff1a807&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff1a807"]])

export default __exports__